export default __webpack_public_path__ + "static/media/logo-lg.89a62f3b.svg";